import { useState, useEffect } from 'react';
import { ApiUrl } from "../../ApiUrl";

const useFetchHouses = () => {
  const [houses, setHouses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
 
  const url = `${ApiUrl.apiurl}SCHOOLHOUSE/GetAllHouse/`;

  useEffect(() => {
    const fetchHouses = async () => {
      try {
        const response = await fetch(url);
        const data = await response.json();
        if (response.ok) {
          setHouses(Array.isArray(data?.data) ? data.data : []);
        } else {
          setError('Error fetching house data');
        }
      } catch (error) {
        setError(error.message || 'Error fetching house data');
        setHouses([]);
      } finally {
        setLoading(false);
      }
    };

    fetchHouses();
  }, []);

  return { houses, loading, error };
};

export default useFetchHouses;
